// 全局的过滤器
import Vue from 'vue'
import moment from 'moment'

import toChinesNum from '~/utils/toChinesNum'

// 默认：YYYY-MM-DD 若需要其他格式 则传递第二个参数
Vue.filter('dataFormat', (input, pattern = 'YYYY-MM-DD') => {
  return moment(input).format(pattern)
})

Vue.filter('toChinesNum', (input) => {
  return toChinesNum(input)
})



// WEBPACK FOOTER //
// ./src/utils/filter.js